<template>
  <HeaderBase>
    <div
      class="flex items-center header-title cursor-pointer w-1/5"
      @click="$router.back()">
      <span class="arrow arrow-l arrow-primary"></span>
      <span v-if="contractor">
        <template v-if="isRegistrationRequest">
          <b>Запрос на регистрацию</b>
        </template>
        <template v-else-if="isChangeRequest">
          <b>Запрос на изменение данных</b>
        </template>
        <template v-else>
          <b>Редактирование профиля</b>
        </template>
      </span>
    </div>
    <div class="flex flex-row items-center">

    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    ...mapGetters({
      contractorsGetter: 'contractors/contractors',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    contractor() {
      if (this.id) {
        return this.contractorsGetter(this.id);
      }
      return null;
    },
    isRegistrationRequest() {
      if (!this.contractor) return false;
      return !this.contractor.registered && !this.contractor.verified;
    },
    isChangeRequest() {
      if (!this.contractor) return false;
      return !!this.contractor.registered && !this.contractor.verified;
    },
  },
};
</script>
